module.exports = __webpack_public_path__ + "static/media/badge-percent.ad2d3af5.svg";